module.exports = __webpack_public_path__ + "img/instructionExercise.1fcbb3c9.png";